<template>
  <div class="animated fadeIn overflow-auto"  style="max-height: 400px;">

    <b-card no-body style="margin: 5px;" >
      <b-card-body fluid title="Categories">
        <b-row no-gutters>
          <b-col style="display:contents;">
              <b-card align="center"
                border-variant="primary"
                v-for="category in categories"
                :key="category.id"
                 class="m-1"
                 style="max-width: 150px;"
                 @click="clicked(category)" tag="b-button" no-body
                >
                 <b-card-img-lazy  src="https://picsum.photos/600/300/?image=25"></b-card-img-lazy>
                  <b-card-text ><b>{{category.name}}</b></b-card-text>
                </b-card>
          </b-col>
        </b-row>

      </b-card-body>
    </b-card>
  </div>
</template>


<script>
import Vue from 'vue'


export default {
  name: 'POSCategories',
  props: {
    categories: {
      type: Array,
      default: [],
    }
  },
  components: {},
  data: function() {
    return {
    }
  },
  methods:{
    clicked(category){
      this.$emit('categoryClicked', category);
    }
  }
};
</script>

<style>
</style>
